import {
  Headings,
  SecondaryButton,
  AccordionTable,
  Table,
} from "@sentara-health/optimahealth_web";
import { t } from "i18next";
import { useNavigate } from "react-router";
import { ENROLLMENT_HISTORY } from "routes";
import EnrollmentHistoryHeader from "./EnrollmentHistoryHeader";
import { useBranding, useGlobalState } from "providers";
import { Brand, DeviceTypes } from "utils/models/CommonTypes";
import { useLocation } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import { formatISODateToMDY } from "utils/helpers/DateFormate";
import { sortedmemberIdcoverageEndDate } from "utils/helpers/HelperFn";

// NB: Need to make these exportable in ui library
type TableCell = {
  text: any;
  colspan?: number;
  rowspan?: number;
  tableStyle?: React.CSSProperties;
};

type TableRow = TableCell[];

interface EnrollmentHistoryMember {
  firstName: string;
  lastName: string;
  memberId: string;
  coverageBeginDate: string;
  coverageEndDate: string;
  groupid: string;
  [key: string]: any;
}

interface GroupedEnrollmentHistory {
  groupid: string;
  data: EnrollmentHistoryMember[];
}

const EnrollmentHistoryInfo = () => {
  const navigate = useNavigate();
  const { deviceType } = useGlobalState();
  const isMobile = deviceType === DeviceTypes.MOBILE;
  const location = useLocation();
  const { brandConfig } = useBranding();
  const [enrollmentHistoryDetails, setEnrollmentHistoryDetails] = useState<any>([]);

  const processDetails = () => {
    const data = location.state?.data as EnrollmentHistoryMember[] | undefined;

    if (data) {
      // Validate and sanitize each item
      const validatedData = data.map((item) => ({
        ...item,
        firstName: item.firstName || "",
        lastName: item.lastName || "",
        memberId: item.memberId || "",
        groupId: item.groupId || item.groupid || "",
        coverageBeginDate: item.coverageBeginDate || "",
        coverageEndDate: item.coverageEndDate || "",
      }));

      const sortedData = sortedmemberIdcoverageEndDate(validatedData);
      setEnrollmentHistoryDetails(sortedData);
    }else {
      console.warn("No enrollment history data found in location.state");
      setEnrollmentHistoryDetails([]);
    }
  };

  useEffect(() => {
    processDetails();
  }, []);

  const newSearchBtn = (
    <SecondaryButton
      data-testid="DetailsNewSearchButton"
      className={"secondary_btn btn_block_mob"}
      onClick={() => navigate(`/app/${ENROLLMENT_HISTORY}`)}
    >
      {t("enrollmentHistoryForm.btnNewSearch")}
    </SecondaryButton>
  );

  const tableHeader: TableRow = [
    { text: t("enrollmentHistoryForm.memberName") },
    { text: t("enrollmentHistoryForm.memberId") },
    { text: t("enrollmentHistoryForm.groupId") },
    { text: t("enrollmentHistoryForm.effectiveDate") },
    { text: t("enrollmentHistoryForm.terminationDate") },
  ];

  return (
    <div>
      <EnrollmentHistoryHeader />
      <Headings
        className="redhat_semibold font-twentyfour black-color mb-3"
        level={5}
        text={t("enrollmentHistoryForm.viewDetails")}
        dataTestId="txtEnrollmentHistoryMemberInfoTableTitle"
      />
      {!isMobile && enrollmentHistoryDetails.length > 0 && (
        <Table
          header={tableHeader}
          rows={enrollmentHistoryDetails.map((item: any) => [
            { text: `${item.firstName} ${item.lastName}` },
            { text: item.memberId },
            { text: item.groupId },
            { text: formatISODateToMDY(item.coverageBeginDate) },
            { text: formatISODateToMDY(item.coverageEndDate) },
          ])}
          className="table table-custom-style black-color mb-4"
          data-testid="tblViewDetailsTable"
        />
      )}

      {isMobile && enrollmentHistoryDetails.length > 0 && (
        <div className="mb-4">
          <AccordionTable
            initialActiveIndex={0}
            id="enrollment_history_view_detail_table"
            items={enrollmentHistoryDetails.map((item:any, index:any) => ({
              title: <div>{`${item.firstName} ${item.lastName}`}</div>,
              id: `enrollment_history_view_detail_table_data_${index}`,
              content: (
                <>
                  <div className="mb-3">
                    <div>{t("enrollmentHistoryForm.memberId")}</div>
                    <div>{item.memberId}</div>
                  </div>
                  <div className="mb-3">
                    <div>{t("enrollmentHistoryForm.groupId")}</div>
                    <div>{item.groupId}</div>
                  </div>
                  <div className="mb-3">
                    <div>{t("enrollmentHistoryForm.effectiveDate")}</div>
                    <div>{formatISODateToMDY(item.coverageBeginDate)}</div>
                  </div>
                  <div className="mb-3">
                    <div>{t("enrollmentHistoryForm.terminationDate")}</div>
                    <div>{formatISODateToMDY(item.coverageEndDate)}</div>
                  </div>
                </>
              ),
            }))}
          />
        </div>
      )}
      <div className="mb-4">{newSearchBtn}</div>
    </div>
  );
};

export default EnrollmentHistoryInfo;
